var moduleMap = {
	"./Join_Us": () => {
		return Promise.all([__webpack_require__.e(377), __webpack_require__.e(704), __webpack_require__.e(631), __webpack_require__.e(868), __webpack_require__.e(759), __webpack_require__.e(407)]).then(() => (() => ((__webpack_require__(8006)))));
	},
	"./Joinus": () => {
		return Promise.all([__webpack_require__.e(377), __webpack_require__.e(896), __webpack_require__.e(631), __webpack_require__.e(868), __webpack_require__.e(945), __webpack_require__.e(191), __webpack_require__.e(697)]).then(() => (() => ((__webpack_require__(2697)))));
	},
	"./Spalsh": () => {
		return Promise.all([__webpack_require__.e(377), __webpack_require__.e(896), __webpack_require__.e(631), __webpack_require__.e(868), __webpack_require__.e(945), __webpack_require__.e(902)]).then(() => (() => ((__webpack_require__(902)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});